import { useNavigate } from 'react-router-dom';
import HSGLogo from '@/components/feature/HSGLogo';

const currentYear = new Date().getFullYear();

const footerLinks = [
  { label: 'About Us', path: '/about' },
  { label: 'Philosophy', path: '/philosophy' },
  { label: 'Services', path: '/services' },
  { label: 'Property Types', path: '/properties' },
  { label: 'Our Team', path: '/team' },
  { label: 'Contact', path: '/contact' },
];

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="w-full bg-[#F5F3F0] py-16 px-6 md:px-16 border-t border-[#E8E6E3]">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start gap-10 mb-12">
          {/* Brand */}
          <div className="flex flex-col gap-4">
            <HSGLogo variant="dark" size="sm" />
            <p className="text-[#6B6B6B] text-xs font-light max-w-xs leading-relaxed">
              Premium rental management for select clientele. By reference only.
            </p>
            <button
              onClick={() => navigate('/portal')}
              className="inline-flex items-center gap-2 bg-[#2C2C2C] hover:bg-[#1A1A1A] text-white text-xs px-4 py-2.5 rounded-md transition-colors cursor-pointer whitespace-nowrap w-fit"
            >
              <i className="ri-shield-keyhole-line"></i>
              Client Portal
            </button>
          </div>

          {/* Nav Links */}
          <div className="flex flex-wrap gap-x-12 gap-y-4">
            {footerLinks.map((link) => (
              <a
                key={link.path}
                href={link.path}
                onClick={(e) => { e.preventDefault(); navigate(link.path); }}
                className="text-xs text-[#6B6B6B] hover:text-[#1A1A1A] tracking-wide transition-colors cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>

        <div className="flex flex-col sm:flex-row justify-between items-center pt-8 border-t border-[#E0DDD9] gap-4">
          <p className="text-xs text-[#9A9A9A]">
            &copy; {currentYear} Higher Standard Global. All rights reserved.
          </p>
          <p className="text-xs text-[#9A9A9A] italic">
            By Reference Only
          </p>
        </div>
      </div>
    </footer>
  );
}
